// TV Millionario's sounds (public/tv-milionario/sound). Every file name is
// lower case; keep it that way, the server is case-sensitive.
//
// "machine" ones are cut from clean captures of the real game on YouTube
// (3VRlTIPI0To, qzZSNKlRcCg; the same sounds recur in Jx0bSxsOPKY,
// 9RTb2wgGdnY and ECdzTa0tdpA, mel NCC 0.85-1.0). Of the supplied .ogg set
// only linhapremiada is heard in any of those five videos; the rest are
// placed by their names and used only where no machine sound was found.
// Loops are .wav: an .mp3 carries encoder padding and would gap each lap.
const SND = `${process.env.PUBLIC_URL}/tv-milionario/sound`;

export const TV_SND = {
    // machine
    spinRoll: "spin-roll.mp3",          // 3VRl 17.94s, every spin
    winLine: "linhapremiada.ogg",       // one per winning line, 0.53s apart
    payout: "payout.mp3",               // 3VRl 36.52s: GANA paid into CRÉDITO
    youWin: "youwin.mp3",               // 3VRl 206.82s: under YOU WIN, host and hostess alike
    jackpotIntro: "jackpot-intro.mp3",  // qzZS 51.91s: from the 3 JACKPOTs landing...
    jackpotLoop: "jackpot-loop.wav",    // ...then the board's bed, 5.404s (88.2s)
    wheelIntro: "wheel-intro.mp3",      // 3VRl 111.00s: LUCKY WHEEL title, rise, first turns
    wheelSpinLoop: "wheel-spin-loop.wav", // 115.16s, 1.366s, while it turns
    wheelStop: "wheel-stop.mp3",        // 118.50s: the stop and the fountain, 8.2s
    wheelCountLoop: "wheel-count-loop.wav", // 160.1s, 2.936s, while the pot counts into GANA
    // supplied, not heard in the videos
    lines: "bip_linhas.ogg",
    bet: "bip_aposta.ogg",
    coinIn: "coinin.ogg",
    bigWinStart: "premio_alto_start.ogg",
    bigWin: "premio_alto.ogg",
    selOpen: "free/fg_sel_open.ogg",
    selTick: "free/fg_sel_bip1.ogg",
    selPick: "free/fg_sel_bip2.ogg",
    creditIn: "free/fg_crentrada.ogg",
    creditTv: "free/fg_cr_tv.ogg",
    selectBeep: "free/refactored/selectbeep.ogg",
};

const cache = {};
const get = (name) => {
    if (!cache[name]) {
        cache[name] = new Audio(`${SND}/${name}`);
        cache[name].preload = "auto";
    }
    return cache[name];
};

export const preloadTvSounds = () => Object.values(TV_SND).forEach(get);

// from the top every time; loop for beds
export const playTv = (name, loop = false) => {
    const a = get(name);
    a.onended = null;
    a.loop = loop;
    a.currentTime = 0;
    a.play().catch(() => { });
    return a;
};

// `first` once, then `then` looping, until stopTv(first, then)
export const chainTv = (first, then) => {
    const a = playTv(first);
    a.onended = () => playTv(then, true);
};

export const isPlayingTv = (...names) => names.some((n) => cache[n] && !cache[n].paused);

export const stopTv = (...names) => names.forEach((n) => {
    const a = cache[n];
    if (!a) return;
    a.onended = null;
    a.pause();
    a.currentTime = 0;
});
